import { actionTextColor } from "../../utils/themeContrast";
import React from "react";
import styled from "@emotion/styled";
import { ThemeContext, LanguageContext, UserContext } from "../../contexts/Context";
import IconLibrary from './IconLibrary';

const Modal = ({
  show,
  setShowDelive,
  confirmDelivery,
  lanIndex,
  setDeliveryType,
  type,
  currencySymbol,
  deliveryPrice,
  includeDineIn,
  deliveryOrNot,
  tkDiMenuDiff,
  hasTakeAway,
  setDeliveryPrice
}) => {
  //State
  const displayShow = show ? "grid" : "none";
  const themeContext = React.useContext(ThemeContext);
  const languageContext = React.useContext(LanguageContext);
  const { deliveryCalMethod, deliveryCosts, isInRoom, company } = React.useContext(UserContext);
  const useSgLabels = company?._id === "69af99cff1e160b6e7187d44";

  return (
    <ModalContainer display={displayShow} role="presentation">
      <ModalMain themeContext={themeContext}>
        <ModalHeader>
          <Eyebrow themeContext={themeContext}>{languageContext[lanIndex].order}</Eyebrow>
          <ModalTitle>{languageContext[lanIndex].howWouldYouLikeToOrder}</ModalTitle>
        </ModalHeader>
        <OptionGrid>
          {(includeDineIn && !tkDiMenuDiff) &&
            <ServiceOption type="button" selected={Number(type) === 1} themeContext={themeContext} onClick={() => { setDeliveryType(1) }}>
              <IconCircle selected={Number(type) === 1} themeContext={themeContext}>
                {Number(type) === 1 ?
                  IconLibrary.dineInUnfocus(themeContext.fontPrimary)
                  :
                  IconLibrary.dineInFocus()
                }
              </IconCircle>
              <OptionCopy>
                <OptionTitle>{useSgLabels ? "Dine In (SG1)" : "Dine In"}</OptionTitle>
              </OptionCopy>
              <SelectionMark selected={Number(type) === 1} themeContext={themeContext} />
            </ServiceOption>
          }
          {hasTakeAway &&
            <ServiceOption type="button" selected={Number(type) === 0} themeContext={themeContext} onClick={() => { setDeliveryType(0) }}>
              <IconCircle selected={Number(type) === 0} themeContext={themeContext}>
                {Number(type) === 0 ?
                  IconLibrary.takeAwayUnfocus(themeContext.fontPrimary)
                  :
                  IconLibrary.takeAwayFocus()
                }
              </IconCircle>
              <OptionCopy>
                <OptionTitle>{useSgLabels ? "Pick Up (SG1)" : "Pick Up"}</OptionTitle>
              </OptionCopy>
              <SelectionMark selected={Number(type) === 0} themeContext={themeContext} />
            </ServiceOption>
          }
          {deliveryOrNot &&
            <ServiceOption type="button" selected={Number(type) === 2} themeContext={themeContext} onClick={() => { setDeliveryType(2); }}>
              <IconCircle selected={Number(type) === 2} themeContext={themeContext}>
                {Number(type) === 2 ?
                  IconLibrary.deliveryUnfocus(themeContext.fontPrimary)
                  :
                  IconLibrary.deliveryFocus()
                }
              </IconCircle>
              <OptionCopy>
                <OptionTitle>{useSgLabels ? "Pick Up (SG2)" : languageContext[lanIndex].delivery}</OptionTitle>
              </OptionCopy>
              <SelectionMark selected={Number(type) === 2} themeContext={themeContext} />
            </ServiceOption>
          }
        </OptionGrid>
        {deliveryCalMethod == 0 && deliveryPrice > 0 && Number(type) === 2 &&
            <FeeNotice themeContext={themeContext}>
              {`${languageContext[lanIndex].deliveryFee}: ${currencySymbol} ${deliveryPrice}`}
            </FeeNotice>
          }
        <ModalButtonContainer>
          <SecondaryButton type="button" themeContext={themeContext} onClick={() => setShowDelive(false)}>
            {languageContext[lanIndex].cancel}
          </SecondaryButton>
          <PrimaryButton type="button" themeContext={themeContext} onClick={() => {
            setShowDelive(false);
            if (isInRoom && deliveryCosts.length > 0) setDeliveryPrice(deliveryCosts[0].deliveryPrice);
            confirmDelivery(type);
          }}>
            {languageContext[lanIndex].continue || languageContext[lanIndex].ok}
          </PrimaryButton>
        </ModalButtonContainer>
      </ModalMain>
    </ModalContainer>
  );
};

export default Modal;



const ModalContainer = styled.div`
  display: ${(props) => props.display};
  position: fixed;
  inset: 0;
  width: 100%;
  min-height: 100dvh;
  padding: 18px;
  box-sizing: border-box;
  place-items: center;
  background: rgba(15, 23, 42, 0.62);
  backdrop-filter: blur(4px);
  z-index: 20;
`;

const ModalMain = styled.div`
  display: flex;
  flex-direction: column;
  width: min(100%, 520px);
  max-height: calc(100dvh - 36px);
  border-radius: 20px;
  position: relative;
  
  font-family: ${(props) => props.themeContext.fontFamily};
  background: ${(props) => props.themeContext.backgroundColor || "#fff"};
  color: ${(props) => props.themeContext.fontPrimary};
  box-shadow: 0 24px 70px rgba(0, 0, 0, 0.28);
  z-index: 10;
  padding: 26px;
  animation: modalIn 180ms ease-out;

  @keyframes modalIn {
    from { opacity: 0; transform: translateY(12px) scale(0.98); }
    to { opacity: 1; transform: translateY(0) scale(1); }
  }

  @media (max-width: 600px) {
    width: 100%;
    max-height: calc(100dvh - 12px);
    margin-top: auto;
    padding: 22px 18px calc(18px + env(safe-area-inset-bottom));
    border-radius: 20px 20px 0 0;
  }
`;
const ModalHeader = styled.div`
  margin-bottom: 20px;
  text-align: left;
`;
const Eyebrow = styled.div`
  margin-bottom: 5px;
  color: ${(props) => props.themeContext.fontPrimary};
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  opacity: 0.66;
`;
const ModalTitle = styled.h2`
  margin: 0;
  font-size: 24px;
  line-height: 1.25;
`;
const OptionGrid = styled.div`
  display: grid;
  gap: 10px;
`;
const ServiceOption = styled.button`
  display: grid;
  grid-template-columns: 48px minmax(0, 1fr) 22px;
  gap: 13px;
  width: 100%;
  min-height: 76px;
  padding: 12px 14px;
  align-items: center;
  border: 1.5px solid ${(props) => props.selected ? props.themeContext.fontPrimary : "rgba(15, 23, 42, 0.13)"};
  border-radius: 14px;
  color: ${(props) => props.themeContext.fontPrimary};
  background: ${(props) => props.selected ? "rgba(15, 23, 42, 0.045)" : "rgba(255, 255, 255, 0.72)"};
  font-family: inherit;
  text-align: left;
  cursor: pointer;
  transition: border-color 150ms ease, transform 150ms ease, box-shadow 150ms ease;

  &:hover { transform: translateY(-1px); box-shadow: 0 7px 18px rgba(15, 23, 42, 0.08); }
  &:focus-visible { outline: 3px solid rgba(15, 23, 42, 0.16); outline-offset: 2px; }
`;
const IconCircle = styled.span`
  display: grid;
  width: 48px;
  height: 48px;
  place-items: center;
  border-radius: 13px;
  background: rgba(15, 23, 42, 0.055);

  svg { max-width: 36px; max-height: 36px; }
`;
const OptionCopy = styled.span`
  display: flex;
  min-width: 0;
  flex-direction: column;
  gap: 4px;
`;
const OptionTitle = styled.span`
  font-size: 16px;
  font-weight: 800;
`;
const SelectionMark = styled.span`
  width: 18px;
  height: 18px;
  box-sizing: border-box;
  border: 2px solid ${(props) => props.selected ? props.themeContext.fontPrimary : "#cbd0d8"};
  border-radius: 50%;
  box-shadow: ${(props) => props.selected ? `inset 0 0 0 4px #fff` : "none"};
  background: ${(props) => props.selected ? props.themeContext.fontPrimary : "transparent"};
`;
const FeeNotice = styled.div`
  margin-top: 12px;
  padding: 10px 12px;
  border-radius: 10px;
  color: ${(props) => props.themeContext.fontPrimary};
  background: rgba(15, 23, 42, 0.055);
  font-size: 13px;
  font-weight: 700;
`;
const ModalButtonContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1.35fr;
  gap: 10px;
  margin-top: 22px;
`;
const ActionButton = styled.button`
  min-height: 48px;
  padding: 0 18px;
  border-radius: 12px;
  font-family: inherit;
  font-size: 15px;
  font-weight: 800;
  cursor: pointer;
`;
const SecondaryButton = styled(ActionButton)`
  border: 1px solid rgba(15, 23, 42, 0.17);
  color: ${(props) => props.themeContext.fontPrimary};
  background: transparent;
`;
const PrimaryButton = styled(ActionButton)`
  border: 1px solid ${(props) => props.themeContext.fontPrimary};
  color: ${(props) => actionTextColor(props.themeContext, props.themeContext.fontPrimary)};
  background: ${(props) => props.themeContext.fontPrimary};
  box-shadow: 0 7px 18px rgba(15, 23, 42, 0.16);
`;
